import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";

import { Generator } from "./../../resources";

@Injectable()
export class GeneratorService extends BaseDataService<Generator> {
  constructor(http: HttpService) {
    super(http, "generator");
  }

  createInstance(options: any): Generator {
    return new Generator(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
